import { type ReactNode, useCallback, useState } from 'react';
import { ContentHeaderContext } from './context';

interface ContentHeaderProviderProps {
  children: ReactNode;
}

export const ContentHeaderProvider = ({
  children,
}: ContentHeaderProviderProps) => {
  const [headerActions, setHeaderActions] = useState<ReactNode>(null);

  const handleSetHeaderActions = useCallback((actions: ReactNode) => {
    setHeaderActions(actions);
  }, []);

  return (
    <ContentHeaderContext.Provider
      value={{ headerActions, setHeaderActions: handleSetHeaderActions }}>
      {children}
    </ContentHeaderContext.Provider>
  );
};
